export function isPublicEntryPath(pathname: string): boolean {
  return (
    pathname === '/' ||
    pathname === '/callback' ||
    pathname.startsWith('/login')
  );
}
